import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { H5, P } from "../../../AbstractElements";

const DeleteFileModal = ({
  isOpen,
  toggle,
  onDelete,
  fileName,
  deletingFile,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      centered
      backdrop="static"
      keyboard={false}
      className="custom-modal"
    >
      <ModalBody className="text-center">
        <div className="modal-icon">
          <i className="fa fa-warning"></i>
        </div>
        <H5>Confirm Deletion</H5>
        <p className="modal-text">
          Are you sure you want to delete{" "}
          <strong
            style={{
              wordBreak: "break-word", // Ensures long words break
              overflowWrap: "break-word", // Ensures wrapping at appropriate points
              whiteSpace: "normal", // Allows multi-line wrapping
              maxWidth: "100%", // Prevents it from exceeding container width
              display: "block", // Ensures proper wrapping behavior
            }}
          >
            {fileName}?
          </strong>
        </p>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button color="secondary" onClick={() => toggle(false)}>
          Cancel
        </Button>
        <Button color="danger" onClick={onDelete}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteFileModal;
